import { useState, type Dispatch, type SetStateAction, useEffect } from 'react'

import {
    type IUpdateFeedback,
    type IEditFeedback,
    type IFeedback,
    type IFeedbackDto,
    type IFeedbackMode
} from '@/app/types/doctorsType'

import { SectionTitle } from '../SectionTitle/SectionTitle'

import style from './Feedbacks.module.scss'
import { FeedbacksList } from './FeedbacksList/FeedbacksList'
import { Mode } from './Mode/Mode'

interface IProps {
    feedbacksList: IFeedback[] | null
    mode: IFeedbackMode[]
    isPublished: boolean
    setMode: Dispatch<SetStateAction<IFeedbackMode[]>>
    onUpdateFeedback: (dto: IUpdateFeedback, onSuccess?: () => void) => void
    onAddFeedback: (dto: Omit<IFeedbackDto, 'doctorId'>, onSuccess: () => void) => void
    onRemoveFeedback: (feedbackId: string) => void
    isFetchingFeedbacks: boolean
}

export const Feedbacks = (props: IProps) => {
    const {
        feedbacksList,
        mode,
        setMode,
        onUpdateFeedback,
        onRemoveFeedback,
        onAddFeedback,
        isPublished,
        isFetchingFeedbacks
    } = props

    const currentMode = mode.filter((mode) => mode.isChecked)[0]

    const [state, setState] = useState<IEditFeedback[]>([])

    useEffect(() => {
        // TODO: Костыль! Исправить
        setState(feedbacksList?.map((item) => ({ ...item, isEdit: false })) || [])
    }, [feedbacksList])

    return (
        <div className={style.container}>
            <SectionTitle header='Отзывы' description='Редактируйте, добавляйте и принимайте отзывы' />
            <div className={style.feedbacksWrapper}>
                <Mode
                    mode={mode}
                    isPublished={isPublished}
                    setMode={setMode}
                    onAddFeedback={onAddFeedback}
                    setState={setState}
                    isFetchingFeedbacks={isFetchingFeedbacks}
                />
                <FeedbacksList
                    initialState={feedbacksList?.map((item) => ({ ...item, isEdit: false })) || []}
                    state={state}
                    setState={setState}
                    setMode={setMode}
                    filterCode={currentMode.isPublished}
                    onUpdateFeedback={onUpdateFeedback}
                    onRemoveFeedback={onRemoveFeedback}
                    isFetchingFeedbacks={isFetchingFeedbacks}
                />
            </div>
        </div>
    )
}
